// extracted by mini-css-extract-plugin
module.exports = {"containerBody":"styles_containerBody__t6H_5","isReady":"styles_isReady__JX1m0"};